import type { AuthProvider } from 'react-admin';
import { config } from '../../config/config';
import type { User, LoginCredentials, LoginResponse } from '../../types';

const authProvider: AuthProvider = {
  login: async ({ username, password }: LoginCredentials) => {
    const request = new Request(`${config.apiUrl}/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });

    const response = await fetch(request);
    if (response.status < 200 || response.status >= 300) {
      throw new Error(response.statusText);
    }

    const { token, user }: LoginResponse = await response.json();
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    return Promise.resolve({ redirectTo: '/' });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },

  checkAuth: () => {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  },

  checkError: (error: { status?: number }) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        return Promise.reject(new Error('No user found'));
      }
      const user: User = JSON.parse(userStr);
      return Promise.resolve(user);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getPermissions: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return Promise.reject(new Error('No user found'));
    }
    const user: User = JSON.parse(userStr);
    return user ? Promise.resolve(user.role) : Promise.reject();
  },
};

export default authProvider;
